import { GameShell } from '@/app/GameShell';

export function App() {
  return <GameShell />;
}
